import itemSelector from './views/item-selector'
import enumSelector from './views/enum-selector.vue'
import modelSelector from './views/model-selector.vue'
import parameterSelector from './views/parameter-selector.vue'


export default {
    itemSelector,
    enumSelector,
    modelSelector,
    parameterSelector
};
